import styled from "styled-components";
import Hero from "src/components/Hero/Hero";
import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import ReactMarkdown from "react-markdown";
import TitleSection from "src/components/TitleSection/TitleSection";
import SubTitleSection from "src/components/SubTitleSection/SubTitleSection";
import EventFinished from "src/components/EventFinished";
import useResponsiveImageUrl from "src/utils/useResponsiveImageUrl";

const ClubElite2025 = () => {
  const { t } = useTranslation();
  const goldBarBg = useResponsiveImageUrl(
    "promotions/gaming-machines/club-elite-2025/gold-bar.jpg"
  );

  return (
    <ClubEliteDiv>
      <EventFinished scheduleKeyName="clubElite2025" eventType="promotion" />
      <Hero
        bgImage="promotions/gaming-machines/club-elite-2025/Club-elite-hero-image-2400x800px.jpg"
        buttonSettings={null}
        image={
          "promotions/gaming-machines/club-elite-2025/Club-elite-logo-2400x2400px.png"
        }
      />
      <MainContentDiv>
        <container-div>
          <TitleSection
            as={"h2"}
            title={t("clubElite2025.content.subtitle")}
            borderColor="none"
          />
          <Row className="g-4 mb-0 mt-0 align-items-center">
            <Col className="mt-0" xs={12} md={12}>
              <ReactMarkdown className="desc">
                {t("clubElite2025.content.description")}
              </ReactMarkdown>
              <HostedDrawsBox bgImage={goldBarBg}>
                <h4>{t("clubElite2025.content.hostedDraws.title")}</h4>
                <div>
                  <ReactMarkdown>
                    {t("clubElite2025.content.hostedDraws.content")}
                  </ReactMarkdown>
                </div>
              </HostedDrawsBox>
              <ReactMarkdown>{t("clubElite2025.content.total")}</ReactMarkdown>
              <ReactMarkdown>
                {t("clubElite2025.content.qualify")}
              </ReactMarkdown>
            </Col>
          </Row>
        </container-div>
      </MainContentDiv>
      <div className="rules">
        <container-div>
          <SubTitleSection
            as={"h2"}
            subTitle={t("clubElite2025.content.rules.title")}
            className="pt-0"
          />
          <ReactMarkdown>
            {t("clubElite2025.content.rules.content")}
          </ReactMarkdown>
        </container-div>
      </div>
    </ClubEliteDiv>
  );
};

const ClubEliteDiv = styled.div`
  width: 100%;
  height: auto;
  background: var(--black);
  color: var(--white);
  padding-bottom: 1rem;
  .hero_text_container {
    display: none;
  }
  .hero_image {
    padding: 2rem 2rem 4rem;
    @media (min-width: 768px) {
      padding: 3rem;
    }
    opacity: 0.9;
  }

  .small {
    text-align: center;
  }
  .title-section {
    padding: 0;
  }

  div.rules {
    padding: 40px 20px;
    background-color: #111;
    margin-top: 40px;

    h2 {
      font-size: 25px;
    }

    ol {
      margin-top: 0;
      margin-bottom: 10px;
      padding-left: 20px;

      li {
        font-size: 16px;
        color: #999;
        line-height: 1.6;
        margin-bottom: 10px;
      }
    }

    p {
      color: #999;
    }
  }
`;

const MainContentDiv = styled.div`
  padding: 3rem 0 0 0;
  h2 {
    font-size: 28px;
    text-align: center;
    color: #dcb465;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 1px;
    @media (min-width: 768px) {
      font-size: 42px;
    }
  }
  h2:after {
    display: none;
  }
  height: auto;
  width: 100%;
  text-align: center;
  container-div {
    text-align: center;
  }
  p {
    font-size: 20px;
    max-width: 600px;
    margin: 0 auto 20px auto;
    strong {
      color: #dcb465;
    }
  }
  .desc {
    margin-bottom: 30px;
  }

  ul {
    list-style: none;
    p {
      margin: 10px 0;
    }
    li {
      white-space: unset;
    }
  }

  .row {
    display: flex;
    justify-content: space-between;
    position: relative;
    .col-12 {
      .subtitle-section {
        @media (min-width: 768px) {
          padding-top: 0;
        }
      }
    }
  }
`;

const HostedDrawsBox = styled.div`
  background-image: url(${(props) => props.bgImage});
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 0;
  padding: 0;
  margin: 30px auto;
  text-align: center;
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 20px 0;
  width: 100%;
  max-width: 700px;

  h4 {
    margin-top: 10px;
    justify-content: center;
    color: #dcb465;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 20px;
  }

  div {
    margin-top: 20px;
    text-align: center;
    width: 100%;
    p {
      margin: 0 auto;
      color: var(--black);
      strong {
        color: var(--black);
        font-size: 20px;
        font-weight: 900;
        text-transform: uppercase;
      }
    }
  }
  @media (max-width: 768px) {
    background-size: cover;
    h4 {
      margin-top: 2px;
    }
  }
`;

export default ClubElite2025;
